import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';

export const ProfileCreationError: React.FC = () => {
  const { signOut } = useAuth();

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100 dark:bg-gray-900 text-center p-4">
      <h1 className="text-2xl font-bold mb-4">Account Creation Pending</h1>
      <p className="mb-6 text-gray-600 dark:text-gray-400">
        There was an issue creating your user profile. This can sometimes happen during peak times.
      </p>
      <p className="mb-8 text-gray-600 dark:text-gray-400">
        Please log out and try signing in again. If the problem persists, please contact support.
      </p>
      <Button onClick={signOut}>
        Logout and Try Again
      </Button>
    </div>
  );
};